<template>
  <Head title="Planning - Initiative" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <initiative 
            :plan="plan" 
            :initiative="initiative" 
            :client="client"
            :standard_inputs="inputs"
          ></initiative>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  plan: Object,
  initiative: Object,
  client: Object,
  inputs: Array
});
</script>

